import React from 'react'


const smartComm1 = [
    {
        img:"/assets/images/kwikpass/face-scanner.png",
        heading:"Advanced AI Segmentation",
        content:"Behavior-driven audience targeting."
    },
    {
        img:"/assets/images/kwikpass/database.png",
        heading:"Performance Tracking",
        content:"Google Analytics & Meta integrations."
    },
    {
        img:"/assets/images/kwikpass/stats.png",
        heading:"Seamless Data Sync",
        content:"Direct integrations with CRM & marketing platforms."
    },
    
]


const smartComm2 = [
    {
        img:"/assets/images/kwikpass/badge.png",
        heading:"Loyalty & Rewards",
        content:"Enable repeat purchases with reward-based incentives."
    },
    {
        img:"/assets/images/kwikpass/puzzle.png",
        heading:"Universal Compatibility",
        content:"Works across Shopify, custom-built stores & mobile apps."
    },
  
]

export const SectionFive = () => {
  return (
                    <div>
                        <div className="container-fluid">
                            <div className="sec5-heading mt-5 mb-1">
                                <h1>Powering Smarter Commerce with Cutting-Edge Technology</h1>
                            </div>
                            <div className='d-flex justify-content-center sec5-para '>
                                <p>Kwik Engage integrates seamlessly with your existing ecosystem to optimize customer engagement and retention.</p>
                            </div>
                            <div className='mx-4'>
                            <div className="container-fluid">
                            <div className="d-flex flex-wrap justify-content-center gap-4">
                                {smartComm1.map((item, index) => (
                                    <div key={index} className="SmartCard text-start">
                                        <img src={item.img} alt={item.heading} className="mb-2" />
                                        <h4 className="card-head mb-2">{item.heading}</h4>
                                        <p className="card-content">{item.content}</p>
                                    </div>
                                ))}
                            </div>
                        </div>


                        <div className="d-flex flex-wrap justify-content-center gap-3 mt-4 mb-5">
                            {smartComm2.map((item, index) => (
                            <div key={index} className="SmartCard text-start">
                                <img src={item.img} alt={item.heading} className="mb-2" />
                                <h4 className="card-head mb-2">{item.heading}</h4>
                                <p className="card-content">{item.content}</p>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
  )
}


